import React, { useState } from 'react';
import './Contactus.css';
import Navbar from '../../Navbar/Navbar.jsx';


const FAQS = [
  {
    q: 'What are the school timings?',
    a: 'School operates Monday to Saturday. Primary (Classes I–IV): 7:00 AM – 10:30 AM. Secondary (Classes V–X): 11:00 AM – 3:45 PM.',
  },
  {
    q: 'How can I apply for admission?',
    a: 'You can apply online through our Admissions page or visit the school office during working hours. Admission forms are available from January each year.',
  },
  {
    q: 'Is there a school bus facility?',
    a: 'Yes, we provide VAN facility covering major routes in Rairangpur and nearby areas. Contact the school office for route details and fees.',
  },
  {
    q: 'Who do I contact for fee-related queries?',
    a: 'Please contact the accounts office directly at 7655022486 or visit during school hours (9:00 AM – 12:00 PM on weekdays).',
  },
  
  
];

const CONTACT_CARDS = [
  {
    icon: '📞',
    label: 'Phone',
    value: '7655022486',
    sub: 'Mon – Sat, 8 AM – 3 PM',
    href: 'tel:+917655022486',
    action: 'Call Now',
  },
  {
    icon: '✉️',
    label: 'Email',
    value: 'lfsrkrrpmbj@gmail.com',
    sub: 'We reply within 24 hours',
    href: 'mailto:lfsrkrrpmbj@gmail.com',
    action: 'Send Email',
  },
  {
    icon: '📍',
    label: 'Address',
    value: 'Rairangpur PO, Mayurbhanj',
    sub: 'Odisha, India – 757043',
    href: 'https://maps.app.goo.gl/cezsckYmzy3WuHNq9',
    action: 'Get Directions',
  },
  {
    icon: '🕐',
    label: 'Office Hours',
    value: 'Mon – Sat',
    sub: '8:00 AM – 3:00 PM',
    href: null,
    action: null,
  },
];

const ContactUs = () => {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', subject: '', category: '', message: '',
  });
  const [errors, setErrors]     = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending]   = useState(false);
  const [openFaq, setOpenFaq]   = useState(null);

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Name is required.';
    if (!form.email.trim())   e.email   = 'Email is required.';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter a valid email.';
    if (!form.subject.trim()) e.subject = 'Subject is required.';
    if (!form.message.trim()) e.message = 'Message is required.';
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setErrors({});
    setSending(true);
    setTimeout(() => {
      setSending(false);
      setSubmitted(true);
      setForm({ name: '', email: '', phone: '', subject: '', category: '', message: '' });
    }, 1600);
  };

  const F = (field) => ({
    value: form[field],
    onChange: (e) => {
      setForm(f => ({ ...f, [field]: e.target.value }));
      if (errors[field]) setErrors(er => ({ ...er, [field]: '' }));
    },
  });

  return ( 
    <>
    <Navbar/>
    <div className="contact-page">
      

      {/* ── HERO ── */}
      <section className="ct-hero">
        <div className="ct-hero__bg">
          {[...Array(4)].map((_, i) => (
            <div className="ct-hero__circle" key={i} style={{ '--i': i }} />
          ))}
        </div>
        <div className="ct-hero__content">
          <span className="ct-eyebrow">💬 We're Here to Help</span>
          <h1>Contact Us</h1>
          <p>
            Have a question, need directions, or want to talk about admissions?
            Reach out to us — we'd love to hear from you.
          </p>
        </div>
        <div className="ct-hero__image">
          <div className="ct-hero__building">
            <div className="ct-building-card">
              <img
                src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=500&q=80"
                alt="Little flowers' School"
              />
              <div className="ct-building-card__label">
                <span>📍</span>
                <span>LFS , Rairangpur, Odisha</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT CARDS ── */}
      <section className="ct-cards-section">
        <div className="ct-cards">
          {CONTACT_CARDS.map((card, i) => (
            <div className="ct-card" key={card.label} style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="ct-card__icon">{card.icon}</div>
              <div className="ct-card__body">
                <span className="ct-card__label">{card.label}</span>
                <strong className="ct-card__value">{card.value}</strong>
                <span className="ct-card__sub">{card.sub}</span>
              </div>
              {card.href && card.action && (
                <a href={card.href} className="ct-card__link" target="_blank" rel="noreferrer">
                  {card.action} →
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ── MAIN SECTION: form + map ── */}
      <section className="ct-main">

        {/* LEFT: form */}
        <div className="ct-form-col">
          <div className="ct-form-header">
            <span className="ct-section-eyebrow">Send a Message</span>
            <h2>Have Any Queries?</h2>
            <p>Fill in the form and our team will get back to you as soon as possible.</p>
          </div>

          {submitted ? (
            <div className="ct-success">
              <div className="ct-success__icon">✅</div>
              <h3>Message Sent!</h3>
              <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
              <button
                className="ct-success__btn"
                onClick={() => setSubmitted(false)}
              >
                Send Another Message
              </button>
            </div>
          ) : (
            <div className="ct-form">
              <div className="ct-form__row">
                <div className={`ct-field ${errors.name ? 'ct-field--error' : ''}`}>
                  <label>Full Name *</label>
                  <input type="text" placeholder="e.g. Ramesh Kumar" {...F('name')} />
                  {errors.name && <span className="ct-field__err">{errors.name}</span>}
                </div>
                <div className={`ct-field ${errors.email ? 'ct-field--error' : ''}`}>
                  <label>Email Address *</label>
                  <input type="email" placeholder="you@example.com" {...F('email')} />
                  {errors.email && <span className="ct-field__err">{errors.email}</span>}
                </div>
              </div>
              <div className="ct-form__row">
                <div className="ct-field">
                  <label>Phone Number</label>
                  <input type="tel" placeholder="+91 98765 43210" {...F('phone')} />
                </div>
                <div className="ct-field">
                  <label>Query Type</label>
                  <select {...F('category')}>
                    <option value="">Select a topic</option>
                    <option>Admissions</option>
                    <option>Fee Structure</option>
                    <option>Academics</option>
                    <option>Transport</option>
                    <option>Events</option>
                    <option>General Enquiry</option>
                  </select>
                </div>
              </div>
              <div className={`ct-field ${errors.subject ? 'ct-field--error' : ''}`}>
                <label>Subject *</label>
                <input type="text" placeholder="Brief subject of your message" {...F('subject')} />
                {errors.subject && <span className="ct-field__err">{errors.subject}</span>}
              </div>
              <div className={`ct-field ${errors.message ? 'ct-field--error' : ''}`}>
                <label>Message *</label>
                <textarea
                  placeholder="Write your message here..."
                  rows={5}
                  {...F('message')}
                />
                {errors.message && <span className="ct-field__err">{errors.message}</span>}
              </div>

              <button
                className={`ct-submit ${sending ? 'ct-submit--sending' : ''}`}
                onClick={handleSubmit}
                disabled={sending}
              >
                {sending ? (
                  <><span className="ct-spinner" /> Sending...</>
                ) : (
                  '🚀 Send Message'
                )}
              </button>
            </div>
          )}
        </div>

        {/* RIGHT: info + map */}
        <div className="ct-info-col">
          <div className="ct-info-header">
            <span className="ct-section-eyebrow">Find Us</span>
            <h2>Visit Our School</h2>
            <p>We're located at Rairangpur, Mayurbhanj — a peaceful campus in the heart of Odisha.</p>
          </div>

          {/* Map embed */}
          <div className="ct-map">
            <iframe
              title="Little Flowers' School Location"
              src="https://maps.app.goo.gl/cezsckYmzy3WuHNq9"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="ct-map__overlay">
              <a
                href="https://maps.app.goo.gl/cezsckYmzy3WuHNq9"
                target="_blank"
                rel="noreferrer"
                className="ct-map__open"
              >
                🗺 Open in Google Maps
              </a>
            </div>
          </div>

          {/* Details block */}
          <div className="ct-detail-block">
            <div className="ct-detail-row">
              <span className="ct-detail-icon">🏫</span>
              <div>
                <strong>Little Flowers' School</strong>
                <span>Affiliation No. 153047</span>
              </div>
            </div>
            <div className="ct-detail-row">
              <span className="ct-detail-icon">📍</span>
              <div>
                <strong>RAIRANGPUR, MAYURBHANJ</strong>
                <span>Odisha, India – 757043</span>
              </div>
            </div>
            <div className="ct-detail-row">
              <span className="ct-detail-icon">📞 +91 76550 22486</span>
              
            </div>
            <div className="ct-detail-row">
              <span className="ct-detail-icon">✉️</span>
              <div>
                <strong>lfsrkrrpmbj@gmail.com</strong>
                <span>Replies within 1 working day</span>
              </div>
            </div>
          </div>

          {/* Social row */}
          <div className="ct-socials">
            <span>Follow Us</span>
            <div className="ct-socials__links">
              {[
                { icon: 'f',  label: 'Facebook', href: '#' },
                { icon: '▶', label: 'YouTube',   href: '#' },
                { icon: 'in', label: 'LinkedIn',  href: '#' },
                { icon: '✕',  label: 'X',         href: '#' },
              ].map(s => (
                <a key={s.label} href={s.href} className="ct-social" aria-label={s.label}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ SECTION ── */}
      <section className="ct-faq">
        <div className="ct-faq__header">
          <span className="ct-section-eyebrow">Quick Answers</span>
          <h2>Frequently Asked Questions</h2>
          <p>Can't find your answer? Use the contact form above and we'll respond promptly.</p>
        </div>
        <div className="ct-faq__list">
          {FAQS.map((faq, i) => (
            <div
              className={`ct-faq__item ${openFaq === i ? 'ct-faq__item--open' : ''}`}
              key={i}
            >
              <button
                className="ct-faq__q"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <span>{faq.q}</span>
                <span className="ct-faq__chevron">{openFaq === i ? '−' : '+'}</span>
              </button>
              <div className="ct-faq__a">
                <p>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── BOTTOM CTA ── */}
      <section className="ct-cta">
        <div className="ct-cta__deco" />
        <div className="ct-cta__content">
          <h2>Ready to Visit LFS ?</h2>
          <p>Schedule a campus tour and experience our vibrant learning environment firsthand.</p>
          <div className="ct-cta__btns">
            <a href="/assignments" className="ct-cta-btn ct-cta-btn--white">
              📋 View Assignments
            </a>
            <a href="/gallery" className="ct-cta-btn ct-cta-btn--outline">
              🖼 Explore Gallery
            </a>
          </div>
        </div>
      </section>

    
    </div>
    </>
  );
};

export default ContactUs;